import React, { useEffect, useRef, useState } from "react";

const ScrollAnimation = ({
  children,
  direction = "left",
  delay = 0,
  duration = 600,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  const getTransform = () => {
    if (!isVisible) {
      switch (direction) {
        case "left":
          return "translateX(-50px)";
        case "right":
          return "translateX(50px)";
        case "up":
          return "translateY(30px)";
        case "down":
          return "translateY(-30px)";
        default:
          return "translateX(-50px)";
      }
    }
    return "translateX(0) translateY(0)";
  };

  const getOpacity = () => {
    return isVisible ? 1 : 0;
  };

  return (
    <div
      ref={elementRef}
      style={{
        opacity: getOpacity(),
        transform: getTransform(),
        transition: `opacity ${duration}ms ease-out ${delay}ms, transform ${duration}ms ease-out ${delay}ms`,
      }}
    >
      {children}
    </div>
  );
};

export default ScrollAnimation;

